import { FontSize, ThemeMode, ThemeSettings } from '../types/theme';

export const DEFAULT_THEME_SETTINGS: ThemeSettings = {
  fontSize: FontSize.normal,
  themeMode: ThemeMode.default,
  isArialFont: false,
  isHighlightLinks: false,
};
